import { notification } from 'antd';
import {
  HiOutlineCheckCircle,
  HiOutlineExclamationCircle,
} from 'react-icons/hi2';

type NotificationType = 'success' | 'error';

const getProperIconByType = (type: NotificationType): JSX.Element => {
  return type === 'success'
    ? <HiOutlineCheckCircle size={22} />
    : <HiOutlineExclamationCircle size={22} />;
}

export const notify = (type: NotificationType, description: string): void => {
  notification[type]({
    message: '',
    description,
    className: 'upwex-notification',
    duration: 4,
    icon: getProperIconByType(type),
    closeIcon: null,
  });
}
